import React from 'react';

const ProductInfo = ({ productForEdit }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 gap-2 mb-2">
      <div className="bg-gray-100 p-2 rounded-lg">
        <h3 className="font-semibold mb-2">Product Description</h3>
        <div>
          <div className="mb-1">Description:</div>
          <div>
            {productForEdit?.mainProduct?.itemDescription} {' - '}{' '}
            {productForEdit?.mainProduct?.description2}
          </div>
        </div>
      </div>

      <div className="bg-gray-100 p-4 rounded-lg text-sm">
        <h3 className="font-semibold mb-2">Pricing & Quantity</h3>
        <div className="space-y-1">
          <div>
            Price 0:{' '}
            {isFinite(productForEdit?.mainProduct?.price0exGst)
              ? productForEdit?.mainProduct?.price0exGst
              : ''}{' '}
            <br /> Qty 0:{' '}
            {isFinite(productForEdit?.mainProduct?.qtyBreak0)
              ? productForEdit?.mainProduct?.qtyBreak0
              : ''}
          </div>
          <div>
            Price 1:{' '}
            {isFinite(productForEdit?.mainProduct?.price1exGst)
              ? productForEdit?.mainProduct?.price1exGst
              : ''}{' '}
            <br /> Qty 1:{' '}
            {isFinite(productForEdit?.mainProduct?.qtyBreak1)
              ? productForEdit?.mainProduct?.qtyBreak1
              : ''}
          </div>
          <div>
            Price 2:{' '}
            {isFinite(productForEdit?.mainProduct?.price2exGst)
              ? productForEdit?.mainProduct?.price2exGst
              : ''}{' '}
            <br /> Qty 2:{' '}
            {isFinite(productForEdit?.mainProduct?.qtyBreak2)
              ? productForEdit?.mainProduct?.qtyBreak2
              : ''}
          </div>
          <div>
            Price 3:{' '}
            {isFinite(productForEdit?.mainProduct?.price3exGst)
              ? productForEdit?.mainProduct?.price3exGst
              : ''}{' '}
            <br /> Qty 3:{' '}
            {isFinite(productForEdit?.mainProduct?.qtyBreak3)
              ? productForEdit?.mainProduct?.qtyBreak3
              : ''}
          </div>
          <div>
            Price 4:{' '}
            {isFinite(productForEdit?.mainProduct?.price4exGst)
              ? productForEdit?.mainProduct?.price4exGst
              : ''}{' '}
            <br /> Qty 4:{' '}
            {isFinite(productForEdit?.mainProduct?.qtyBreak4)
              ? productForEdit?.mainProduct?.qtyBreak4
              : ''}
          </div>
        </div>
      </div>

      <div className="bg-gray-100 p-4 rounded-lg">
        <h3 className="font-semibold mb-2">Stock Information </h3>
        <div className="space-y-1">
          <div>Managed Range: {productForEdit?.mainProduct?.managedRange}</div>
          <div>FLC Page No: {productForEdit?.mainProduct?.flcPageNo}</div>
          <div>
            Available Online:{' '}
            {productForEdit?.mainProduct?.internetFlag ? 'Yes' : 'No'}
          </div>
        </div>
      </div>

      <div className="bg-gray-100 p-4 rounded-lg">
        <h3 className="font-semibold mb-2">Warehouse Information</h3>
        <div className="space-y-1">
          <div>
            WHSE Max:{' '}
            {isFinite(productForEdit?.mainProduct?.maximumStock)
              ? productForEdit?.mainProduct?.maximumStock
              : ''}
          </div>
          <div>
            WHSE Min:{' '}
            {isFinite(productForEdit?.mainProduct?.minimumStock)
              ? productForEdit?.mainProduct?.minimumStock
              : ''}
          </div>
          <div>Bin Location: {productForEdit?.mainProduct?.binLoc}</div>
        </div>
      </div>
    </div>
  );
};

export default ProductInfo;
